import React, { useEffect, useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  LabelList,
  Cell,
  Text,
  Brush,
} from "recharts"
import { Button } from "antd"
import {
  searchItemInTree,
  validate,
  searchTree,
  browserSize,
} from "../../../utils/functions"
import CustomTooltip from "./components/CustomTooltip"
import { SURVEY_CALCULATION_TYPE } from "../../../utils/constants"

const toPercent = (decimal) => {
  return `${decimal.toFixed(0)}%`
}

const renderCustomizedLabel = (props, auxData, calculationType) => {
  const { x, y, width, name, value, index } = props
  const radius = 10
  const currentData = auxData[index]
  if (currentData.employees < currentData.anonymity_check.current_used) {
    return null
  }

  return (
    <g>
      <text
        x={x + width / 2}
        y={y - radius}
        fill="#3482D7"
        fontSize={12}
        textAnchor="middle"
        dominantBaseline="middle">
        {calculationType === 2 ? `${value}` : `${Math.round(value)}%`}
      </text>
    </g>
  )
}

export function BarChartDivisionNotHistory(props) {
  const [divisionParent, setDivisionParent] = useState(0)
  const [dataChart, setDataChart] = useState([])

  const isCalculationTopTwoBox =
    props.calculationType === SURVEY_CALCULATION_TYPE.topTwoBox
  const widthChart = dataChart.length * 145
  const sizeBrowser = browserSize()
  const styleChart =
    sizeBrowser.width - 135 < widthChart ? { width: `${widthChart}px` } : null

  useEffect(() => {
    const { divisionsDrillDown } = props
    let result = []
    if (divisionParent === 0) {
      result = [...divisionsDrillDown]
    } else {
      result = searchTree([...divisionsDrillDown], divisionParent)
    }
    result = result.map((item) => {
      if (item.employees < item.anonymity_check.current_used) {
        item.percent = isCalculationTopTwoBox ? 100 : 5
      }
      return item
    })
    setDataChart(result)
  }, [props.divisionsDrillDown])

  useEffect(() => {
    const { divisionsDrillDown } = props
    let result = []
    if (divisionParent === 0) {
      result = [...divisionsDrillDown]
    } else {
      result = searchTree([...divisionsDrillDown], divisionParent)
    }
    result = !validate.exist(result) ? [...divisionsDrillDown] : result
    result = result.map((item) => {
      if (item.employees < item.anonymity_check.current_used) {
        item.percent = isCalculationTopTwoBox ? 100 : 5
      }
      let showValue = true
      if (item.value === 0 && item.childs && item.childs.length > 0) {
        item.percent = isCalculationTopTwoBox ? 100 : 5
        showValue = false
      }

      if (item.value === 0  && item.recipients === 0){
        item.percent =100

        showValue = false
      }
      item.showValue = showValue
      return item
    })
    
    setDataChart(result)
  }, [divisionParent])

  const getDataChildren = (data) => {
    if (validate.exist(data.childs) && data.childs.length > 0) {
      setDivisionParent(data.id)
    }
  }

  const getBackData = (idDivisionParent) => {
    const result = searchItemInTree(
      [...props.divisionsDrillDown],
      idDivisionParent
    )
    setDivisionParent(result.id_parent)
  }

  const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props
    return (
      <Text
        x={x}
        y={y}
        width={100}
        padding={{ bottom: 20 }}
        textAnchor="middle"
        verticalAnchor="start">
        {payload.value}
      </Text>
    )
  }

  return (
    <div
      className="BarChartDivisionNotHistory"
      style={{ paddingTop: "40px", ...styleChart }}>
      {validate.exist(divisionParent) && divisionParent != 0 ? (
        <Button
          style={{ marginTop: "-2rem" }}
          className="BarChartDivisionNotHistory-button"
          type="primary"
          onClick={() => getBackData(divisionParent)}>
          Regresar
        </Button>
      ) : null}
      <ResponsiveContainer>
        <BarChart
          data={dataChart}
          margin={{
            top: 28,
            right: 0,
            bottom: 28,
            left: -20,
          }}>
          <CartesianGrid vertical={false} stroke="#EDE9E9" />
          <XAxis
            axisLine={false}
            tickLine={false}
            tickMargin={10}
            height={90}
            dataKey="name"
            type="category"
            interval={0}
            tick={<CustomizedAxisTick />}
            padding={{ left: 40, right: 40 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickCount={6}
            type="number"
            tick={{ fill: "#8D8A8D", fontSize: "12" }}
            domain={props.calculationType === 2 ? [0, 5] : [0, 100]}
            tickFormatter={props.calculationType === 2 ? null : toPercent}
          />
          <Tooltip
            content={(element) => (
              <CustomTooltip
                element={element}
                measureGeneral={props.measureGeneral}
              />
            )}
            cursor={{ fill: "transparent" }}
          />
          <Legend
            verticalAlign={props.legendVerticalAlign}
            height={36}
            wrapperStyle={props.legendMargin}
            payload={[
              {
                value: "Divisiones",
                type: "rect",
                id: "ID01",
                color: "#3482D7",
              },
              {
                value: "Organización",
                type: "line",
                id: "ID02",
                color: "#56CCF2",
              },
            ]}
          />
          <Bar
            name="Divisiones"
            dataKey="percent"
            barSize={30}
            fill="#3482D7"
            onClick={(data) => getDataChildren(data)}
            radius={[2, 2, 2, 2]}
            isAnimationActive={false}>
            <LabelList
              dataKey={isCalculationTopTwoBox ? "value" : "value_visible"}
              position="top"
              fontSize={10}
              fill="#3482D7"
              formatter={toPercent}
              content={(innerProps) =>
                renderCustomizedLabel(
                  innerProps,
                  dataChart,
                  props.calculationType
                )
              }
            />
            {dataChart.map((entry, index) => {
              return (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    entry.employees < entry.anonymity_check.current_used
                      ? "#D9D9D9"
                      : entry.showValue
                      ? "#3482D7"
                      : "#D9D9D9"
                  }
                />
              )
            })}
          </Bar>
          {validate.exist(props.metric) && (
            <ReferenceLine
              y={props.metric.percent}
              label=""
              stroke="#56CCF2"
              strokeDasharray="3 3"
              strokeWidth={1.5}
            />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

BarChartDivisionNotHistory.propTypes = {
  divisionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metric: PropTypes.object,
  legendVerticalAlign: PropTypes.string,
}
export default BarChartDivisionNotHistory
